import { render } from "./deleteIntensityModal.vue?vue&type=template&id=a2277842"
import script from "./deleteIntensityModal.vue?vue&type=script&lang=js"
export * from "./deleteIntensityModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__